
@if(role==='DISTRIBUTOR' || role==='INSURER' || role==='PROVIDER'){
<div class="agent-card" [class.expanded]="isExpanded" (click)="toggleExpand()">

    <div class="d-flex justify-content-between align-items-center">
        <!-- Left: Avatar + Name -->
        <div class="d-flex align-items-center gap-2">
            <div class="avatar">
                {{agent.firstName | initials : agent.lastName}}
            </div>
            <div class="user-details">
                <div class="fw-500 fs-12">{{ agent.firstName }} {{ agent?.lastName }}</div>
                <div class="text-muted fs-10">{{ agent.phone }}</div>
            </div>
        </div>

        <!-- Right side: Status + Actions -->
        <div class="d-flex align-items-center gap-3 ms-auto flex-wrap">
            <div class="provider-action">
                <div class="chips-container">
                    <span class="chip active-chip" *ngIf="agent.isactive">Active</span>
                    <span class="chip deactive-chip" *ngIf="!agent.isactive">Deactived</span>
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="action-buttons d-flex align-items-center gap-2" *ngIf="!actionHidden">
                @if (!agent.isactive) {
                <span class="icon-btn" matTooltip="Activate" matTooltipPosition="above"
                    (click)="onStatusUpdate(true); $event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="#53e643" fill-rule="evenodd"
                            d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                            clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
                    </svg>
                </span>
                } @else {
                <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="above"
                    (click)="onStatusUpdate(false); $event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                        <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z"
                            stroke-width="0.1" stroke="#e84721" />
                    </svg>
                </span>
                }
                <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
                    (click)="onEditAgent(); $event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                        <path fill="#66AEE0" fill-rule="evenodd"
                            d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                            clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                        <path fill="#66AEE0"
                            d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                            stroke-width="0.1" stroke="#66AEE0" />
                    </svg>
                </span>
            </div>
        </div>

    </div>


    <hr class="divider" *ngIf="isExpanded" />

    <div class="expanded-content" [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'">
        <div class="kv-row">
            <span class="key gray-text">Gender:</span>
            @if(agent.gender){
            <span class="value">{{ agent.gender }}</span>}
            @else{
            <span class="value">-</span>}
        </div>
        <div class="kv-row">
            <span class="key gray-text">DOB:</span>
            @if(agent.dateOfBirth){
            <span class="value">{{ agent.dateOfBirth }}</span>}
             @else{
            <span class="value">-</span>}
        </div>
        <div class="kv-row">
            <span class="key gray-text">Email:</span>
            @if(agent.email){
            <span class="value">{{ agent.email || 'NA' }}
                <span class="copy-icon" (click)="copyToClipboard(agent.email);$event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <path fill="#1976d2"
                            d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 16H8V7h11z" />
                    </svg>
                </span>

                <span *ngIf="copiedEmail === agent.email" class="copied-text"
                    style="margin-left:6px; color: #43a047; font-size: 0.85em;">
                    Copied!
                </span>
            </span>}
        </div>
        <div class="kv-row">
            <span class="key gray-text">Address:</span>
            <span class="value">{{ agent.address || 'NA'}}</span>
        </div>
        <div class="kv-row mb-2" *ngIf="userAccess == enumRole.ADMIN_INSURER">
            <span class="key gray-text">Provider Mapped:</span>
            <span class="value">{{ agent.providerName || 'NA' }}</span>
        </div>
         <div class="kv-row">
            <span class="key gray-text">Start Date:</span>
            <span class="value">
                {{ agent.activeStartDate || 'NA' }}</span>
        </div>
        <div class="kv-row">
            <span class="key gray-text">Activation End Date:</span>
            <span class="value">{{ agent.activeEndDate || 'NA'}}</span>
        </div>
        <div class="kv-row mb-2">
            <span class="key gray-text">Years of exp</span>
            <span class="value">{{ agent.yearsOfExperience || 'NA' }}</span>
        </div>
        <div class="kv-row mb-2">
            <span class="key gray-text">Updated on:</span>
            <span class="value">{{ agent.lastupdatedon | date : 'dd-MM-yyyy HH:mm'  }}</span>
        </div>
    </div>


</div>

}

<!-- @if(role==='DISTRIBUTOR'){
<div class="agent-card" [class.expanded]="isExpanded" (click)="toggleExpand()">

    <div class="d-flex justify-content-between align-items-center"> -->
        <!-- Left: Avatar + Name -->
        <!-- <div class="d-flex align-items-center gap-2">
            <div class="avatar">
                {{agent.name | initials}}
            </div>
            <div class="user-details">
                <div class="fw-500 fs-12">{{ agent.name }}</div>
                <div class="text-muted fs-10">{{ agent.phone }}</div>
            </div>
        </div> -->

        <!-- Right side: Status + Actions -->
        <!-- <div class="d-flex align-items-center gap-3 ms-auto flex-wrap">
            <div class="provider-action">
                <div class="chips-container">
                    <span class="chip deactive-chip" *ngIf="agent.isactive===false">Deactived </span>
                    <span class="chip active-chip" *ngIf="agent.isactive===true">Active</span>
                </div>
            </div> -->

            <!-- Action Buttons -->
            <!-- <div class="action-buttons d-flex align-items-center gap-2" *ngIf="!actionHidden">
                @if (agent.isactive===false) {
                <span class="icon-btn" matTooltip="Activate" matTooltipPosition="above"
                    (click)="onStatusUpdate(true); $event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="#53e643" fill-rule="evenodd"
                            d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                            clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
                    </svg>
                </span>
                } @else { -->
                <!-- <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="above"
                    (click)="onStatusUpdate(false); $event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                        <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z"
                            stroke-width="0.1" stroke="#e84721" />
                    </svg>
                </span>
                }
                <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
                    (click)="onEditAgent(); $event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                        <path fill="#66AEE0" fill-rule="evenodd"
                            d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                            clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                        <path fill="#66AEE0"
                            d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                            stroke-width="0.1" stroke="#66AEE0" />
                    </svg> -->
                <!-- </span>
            </div>
        </div>

    </div> -->


    <!-- <hr class="divider" *ngIf="isExpanded" />

    <div class="expanded-content" [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'">
        <div class="kv-row">
            <span class="key gray-text">Name:</span>
            <span class="value">{{ agent.name || 'NA' }}</span>
        </div>
        
        <div class="kv-row">
            <span class="key gray-text">Email:</span>
            <span class="value">{{ agent.email ||'NA' }}
                <span class="copy-icon" (click)="copyToClipboard(agent.email);$event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                        <path fill="#1976d2"
                            d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 16H8V7h11z" />
                    </svg>
                </span>

                <span *ngIf="copiedEmail === agent.email" class="copied-text"
                    style="margin-left:6px; color: #43a047; font-size: 0.85em;">
                    Copied!
                </span> -->
            <!-- </span>
        </div>
         <div class="kv-row">
            <span class="key gray-text">Start Date:</span>
            <span class="value">
                {{ agent.activeStartDate || 'NA' }}</span>
        </div>
        <div class="kv-row">
            <span class="key gray-text">Activation End Date:</span>
            <span class="value">{{ agent.activeEndDate || 'NA'}}</span>
        </div>
        <div class="kv-row">
        <span class="key gray-text">Phone :</span>
        <span class="value">{{agent.phone || 'NA'}}</span>
        </div>
        <div class="kv-row">
        <span class="key gray-text">Fca Reference Number :</span>
        <span class="value">{{agent.fcaReferenceNumber || 'NA'}}</span>
        </div> -->
        <!-- <div class="kv-row mb-2" *ngIf="userAccess == enumRole.ADMIN_INSURER">
            <span class="key gray-text">Provider Mapped:</span>
            <span class="value">{{ agent.providerName || 'NA' }}</span>
        </div> -->
        

        <!-- <div class="kv-row mb-2">
            <span class="key gray-text">Years of exp</span>
            <span class="value">{{ agent.yearsOfExperience || '—' }}</span>
        </div> -->
        <!-- <div class="kv-row mb-2">
            <span class="key gray-text">Updated on:</span>
            <span class="value">{{ agent.lastupdatedon | date : 'dd-MM-yyyy HH:mm'}}</span>
        </div> -->
    <!-- </div>


</div>

} -->